import BulkListingGenerator from './BulkListingGeneratorPage.js';
export default BulkListingGenerator;